import { Box, Container, Stack } from "@mui/material";
import { Common } from "components";
import { useTheme } from "contexts";

type Props = {};

export const Footer = (props: Props) => {
  const { theme } = useTheme();

  return (
    <Box display="flex" component="footer" bgcolor={theme.color.primary.accent}>
      <Container>
        <Stack
          height={1}
          direction="row"
          alignItems="center"
          pt={theme.spacing.xl}
          pb={theme.spacing.md}
          px={theme.spacing.xl}
          gap={theme.spacing.xs}
          flexWrap={{ xs: "wrap" }}
          className="section-container"
          justifyContent="space-between"
        >
          <Common.Signature />
          <Common.Social
            size="medium"
            items={["facebook", "instagram", "email"]}
          />
        </Stack>
      </Container>
    </Box>
  );
};
